import { LocalStorage } from "@kernel/frontend-react-app";
import { StatsDto } from "./dto";

export class StatsLiveService {
  private storage: LocalStorage<StatsDto>;

  constructor() {
    this.storage = new LocalStorage();
  }

  public getStats(): StatsDto | null {
    const lastKey = this.getLiveStatsKey();
    if (lastKey === null) return null;
    const storedReport = this.storage.get(lastKey);
    if (storedReport === null) return null;
    return storedReport;
  }

  public hasLiveStats(): boolean {
    const keys = Object.keys(window.localStorage);
    return keys.some((key) => key.startsWith("stats"));
  }

  public getLiveStatsKey() {
    const keys = Object.keys(window.localStorage);
    const statsKeys = keys.filter((key) => key.startsWith("stats"));
    const lastKey = statsKeys[statsKeys.length - 1];
    if (lastKey === undefined) {
      console.warn("No stats to get");
      return null;
    }
    return lastKey;
  }

  public subscribe(callback: (stats: StatsDto | null) => void) {
    window.addEventListener("storage", (e: StorageEvent) => {
      const lastKey = this.getLiveStatsKey();
      if (lastKey === null && e.newValue === null) {
        callback(null);
        return;
      }
      if (e.key === lastKey) {
        const stats = this.getStats();
        if (stats !== null) {
          callback(stats);
        }
      }
    });
  }
}
